import ExamDetailComponent from "../../components/Exams/ExamDetailComponent"
import { PageHeader } from "../../school_panel/components/ui";
import { useAuth } from "../../utils/Auth/AuthProvider";

const ExamDetail = () => {
  const { token, role } = useAuth();
  const isAllowed = !!token && (
    role === 'superuser' || role === 'school' || role === 'college_university'
    || role === 'admin' || role === 'school_admin' || role === 'counselor' || role === 'teacher'
  );
  if (!isAllowed) {
    return (
      <>
        <PageHeader title="Exam detail" trail={[{ label: 'Exam list', to: '/exams/exam-list' }]} />
        <div role="alert" className="rounded-[12px] bg-danger-bg p-4 text-danger-ink">You are not authorised to view this exam.</div>
      </>
    );
  }
  // The page header lives in the component: its title and summary come from the loaded exam.
  return <ExamDetailComponent />
}

export default ExamDetail
